import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const GrazeBoxTable = ({ grazeBoxes, onEdit, onDelete }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Graze Boxes
      </Typography>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Base Price</TableCell>
            <TableCell># Sizes</TableCell>
            <TableCell># Dietary Options</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {grazeBoxes.map((box) => (
            <TableRow key={box._id}>
              <TableCell>{box.name}</TableCell>
              <TableCell>{box.category}</TableCell>
              <TableCell>${box.sizes?.[0]?.price || "-"}</TableCell>
              <TableCell>{box.sizes?.length || 0}</TableCell>
              <TableCell>{box.dietaryOptions?.length || 0}</TableCell>
              <TableCell align="right">
                <IconButton onClick={() => onEdit(box)} size="small">
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton onClick={() => onDelete(box)} size="small">
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default GrazeBoxTable;
